import { render, staticRenderFns } from "./CustomersCountries.vue?vue&type=template&id=130bcba2&scoped=true"
import script from "./CustomersCountries.vue?vue&type=script&lang=js"
export * from "./CustomersCountries.vue?vue&type=script&lang=js"
import style0 from "./CustomersCountries.vue?vue&type=style&index=0&id=130bcba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bcba2",
  null
  
)

export default component.exports